import React, { Component } from "react";
import WithConsumer from '../../context/WithConsumer';

export default class PageVideo extends Component {
	
	render () {
		
		let block 		= this.props.block;
		
		document.documentElement.classList.add('state-reverse-header');
		
		if (block) {
									
		    return (
			    
			    <div id={block.id} className={'c-page__block c-page__block--video'}>
			    
			    	<div className="c-video">
			    		
			    		<div className="c-video__inner" dangerouslySetInnerHTML={{__html:'<video src="' + block.video + '" autoplay muted playsinline loop></video>'}}></div>
			    			
						<div className="c-video__logo">
							<svg x="0px" y="0px" viewBox="0 0 1400 333">
								<path d="M962.01,87.01c-69.51,0-112.83,55.06-112.83,122.76l0,0c0,67.7,43.33,122.76,112.83,122.76 c69.96,0,112.38-55.06,112.38-122.76S1031.96,87.01,962.01,87.01z M962.01,301.84c-49.65,0-75.37-40.62-75.37-92.07 c0-51.45,25.73-92.52,75.37-92.52s74.92,41.07,74.92,92.52C1036.93,261.22,1011.65,301.84,962.01,301.84z M1363.23,3.5v122.31h-0.9 c-14.89-22.12-40.17-38.36-73.11-38.36c-57.77,0-102.45,45.13-102.45,122.76l0,0c0,74.92,39.72,122.76,103.36,122.76 c32.95,0,54.61-12.63,72.21-35.2h0.9v28.43h36.55V3.5H1363.23z M1365.49,210.66c0,52.8-22.12,91.62-74.02,91.62 c-44.68,0-67.25-38.82-67.25-91.62c0-52.36,22.57-92.07,66.8-92.07C1339.31,118.59,1365.49,156.5,1365.49,210.66L1365.49,210.66z M357.24,87.01c-66.35,0-110.58,55.06-110.58,122.76l-0.01,0c0,67.7,41.52,122.76,112.83,122.76c52.81,0,89.37-28.43,100.2-78.53 h-35.65c-8.12,31.59-30.69,47.84-64.54,47.84c-46.94,0-72.66-36.11-75.37-83.5h180.54C464.66,141.17,427.2,87.01,357.24,87.01z M285.02,190.81c5.41-42.42,28.89-74.92,72.21-74.92c41.97,0,65.9,28.43,68.15,74.92H285.02z M134.29,3.5H-0.21v322.7h40.62v-135.4 h88.01c70.41,0,104.26-35.65,104.26-94.78c0-24.37-8.12-45.58-21.66-61.38C194.31,14.79,168.14,3.5,134.29,3.5z M125.26,157.86 H40.41V38.71h87.11c41.07,0,64.99,20.31,64.99,59.12C192.51,134.84,170.84,157.86,125.26,157.86z M1112.29,326.21h36.56V3.5h-36.56 V326.21z M611.78,87.45c-33.85,0-57.32,13.99-74.02,36.11h-0.9l0-30.69H500.3v233.34h36.56V182.68c0-38.36,27.08-64.54,64.09-64.54 c32.95,0,52.81,17.15,52.81,47.39v160.67h36.56V162.37C690.31,114.08,660.52,87.45,611.78,87.45z M792.67,61.7 c0-9.3,2.02-15.97,6.05-19.99c4.02-4.02,12.77-6.04,22.07-6.04h39.29V0.8h-41.62c-21.7,0-39.5,5.04-49.27,15.1 c-9.76,10.08-14.64,25.65-14.64,46.72v26.5h-33.1v32.79h35.18v204.3h33.95v-204.3h55.28V89.12h-53.2V61.7z"/>
							</svg>
						</div>
			    		
			    	</div>
			    
			    </div>
			)
			
		} else {
			
			return null;
		
		}
	}
}
